export default [
  {
    title: 'Dashboard',
    route: 'app-deashboard',
    icon: 'ActivityIcon',
    action: 'read',
    resource: 'Analytics',
  },
  {
    title: 'Afiliações',
    icon: 'UsersIcon',
    action: 'read',
    resource: 'Afiliado',
    route: 'app-afiliado-produtos',
    meta: {
      excludeFromAll: true, // Flag customizada
    },
  },
  {
    title: 'Apadrinhados',
    icon: 'UsersIcon',
    action: 'read',
    resource: 'Padrinho',
    route: 'app-admin-apadrinhados',
    meta: {
      excludeFromAll: true, // Flag customizada
    },
  },
  {
    title: 'Cadastros',
    icon: 'PlusSquareIcon',
    action: 'read',
    resource: 'Vendedor',
    children: [
      {
        title: 'Produto',
        route: 'app-adm-produtos',
        icon: 'ArchiveIcon',
        action: 'read',
        resource: 'Vendedor',
      },
      {
        title: 'Tabelas de Preços',
        route: 'app-admin-tabela-precos',
        icon: 'DollarSignIcon',
        action: 'read',
        resource: 'Vendedor',
      },
      {
        title: 'Categorias',
        route: 'app-admin-category',
        icon: 'HashIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
      {
        title: 'Clientes',
        route: 'app-admin-cliente',
        icon: 'UserIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
      {
        title: 'Banner',
        route: 'app-admin-banners',
        icon: 'UserIcon',
        action: 'manage',
        resource: 'all',
      },
    ],
  },
  {
    title: 'Grupos de Permissões',
    icon: 'UsersIcon',
    action: 'read',
    resource: 'ACL',
    children: [
      {
        title: 'Lista de Grupos',
        route: 'app-admin-grupos',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'ACL',
      },
      {
        title: 'Abilidades',
        route: 'app-adm-ability-list',
        icon: 'UserIcon',
        action: 'read',
        resource: 'ACL',
      },
    ],
  },
  {
    title: 'Usuários',
    icon: 'UserPlusIcon',
    action: 'read',
    resource: 'ADMIN_B2C',
    route: 'app-admin-usuario',
  },
  {
    title: 'Pedidos',
    icon: 'UserPlusIcon',
    action: 'read',
    resource: 'Vendedor',
    route: 'app-client-pedido-list',
  },
  {
    title: 'Chat Suporte',
    icon: 'MessageSquareIcon',
    action: 'read',
    resource: 'Vendedor',
    route: 'app-chat-suporte',
  },
  {
    title: 'Minha Loja',
    icon: 'ShoppingBagIcon',
    action: 'read',
    resource: 'Vendedor',
    children: [
      {
        title: 'Configurações',
        route: 'app-minha-loja',
        icon: 'SettingsIcon',
        action: 'read',
        resource: 'Vendedor',
      },
      {
        title: 'Banners',
        route: 'app-minha-loja-banners',
        icon: 'ImageIcon',
        action: 'read',
        resource: 'Vendedor',
      },
      {
        title: 'Categorias',
        route: 'app-minha-loja-categorias',
        icon: 'GridIcon',
        action: 'read',
        resource: 'Vendedor',
      },
    ],
  },
  {
    title: 'Afiliados',
    icon: 'UsersIcon',
    action: 'read',
    resource: 'Vendedor',
    route: 'app-afiliado-afiliacoes',
  },
  {
    title: 'Saque',
    icon: 'DollarSignIcon',
    action: 'read',
    resource: 'Analytics',
    route: 'app-financeiro-saque',
  },
  {
    title: 'Planos',
    icon: 'CreditCardIcon',
    action: 'read',
    resource: 'ADMIN_B2C',
    children: [
      {
        title: 'Gerenciar Planos',
        route: 'app-admin-planos',
        icon: 'PackageIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
      {
        title: 'Assinaturas',
        route: 'app-admin-assinaturas',
        icon: 'CheckSquareIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
    ],
  },
  {
    title: 'Blog',
    icon: 'FileTextIcon',
    action: 'read',
    resource: 'ADMIN_B2C',
    children: [
      {
        title: 'Posts',
        route: 'app-blog',
        icon: 'FileTextIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
      {
        title: 'Agente de IA',
        route: 'app-blog-ai-agent',
        icon: 'CpuIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
    ],
  },
  {
    title: 'Pagamentos',
    icon: 'DollarSignIcon',
    action: 'read',
    resource: 'ADMIN_B2C',
    route: 'app-financeiro-pagamentos',
  },
  {
    title: 'Config. E-commerce',
    route: 'app-adm-settings-ecommerce',
    icon: 'ToolIcon',
    action: 'read',
    resource: 'ADMIN_B2C',
    children: [
      // {
      //   title: 'Config. Geral',
      //   route: 'app-adm-settings-ecommerce',
      //   icon: 'ToolIcon',
      //   action: 'read',
      //   resource: 'ADMIN_B2C',
      // },
      {
        title: 'E-Commerce',
        route: 'app-adm-settings-ecommerce',
        icon: 'ToolIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
      {
        title: 'Integrações',
        route: 'app-adm-settings-integrations',
        icon: 'ToolIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
      {
        title: 'Parâmetros',
        route: 'app-adm-settings-comissions',
        icon: 'ToolIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
      {
        title: 'Parcelas',
        route: 'app-adm-parcelas',
        icon: 'ToolIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },
      {
        title: 'Correios',
        route: 'app-correios-settings',
        icon: 'TruckIcon',
        action: 'read',
        resource: 'ADMIN_B2C',
      },

    ],
  },
]
